import React from 'react';
import TopNav from './TopNav';
import BottomNav from './BottomNav';
import styles from './AppShell.module.scss';

interface AppShellProps {
  children: React.ReactNode;
}

const AppShell: React.FC<AppShellProps> = ({ children }) => {
  return (
    <div className={styles.shell}>
      <TopNav />
      <main className={styles.main}>
        {children}
      </main>
      <BottomNav />
    </div>
  );
};

export default AppShell;
